import { makeStyles } from '@material-ui/styles';
import React from 'react';
// import Comparison from '../Comparison';
import FormEntries from '../Form';
import { Route, Switch, useRouteMatch } from 'react-router';
import TabBar from './TabBar';
import useCheckMobileScreen from '../../../hooks/useWidth';
import FormComparisonLinks from '../Comparison/FormComparisonLinks';
// import Comparison from '../Comparison';

const styles = makeStyles({
    wrapper: {
        marginTop: '15px',
        width: '100%'
    }
});

const TabContext = () => {
    const isMobile = useCheckMobileScreen();
    const classes = styles();
    const { path } = useRouteMatch();

    return (
        <>
            <div>
                {!isMobile && <TabBar />}
                <div className={classes.wrapper}>
                    <Switch>
                        <Route path={`${path}/form`} component={FormEntries} />
                        <Route path={`${path}/comparison`} component={FormComparisonLinks} />
                    </Switch>
                </div>
            </div>
        </>
    );
};

export default TabContext;
